// import { MapsAPILoader, MouseEvent } from '@agm/core';
import { MapsAPILoader, MouseEvent } from "@agm/core";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { ModalDismissReasons, NgbModal } from "@ng-bootstrap/ng-bootstrap";
// import { google } from '@agm/core/services/google-maps-types';
// import {} from '@agm/core/services/google-maps-types';
import { Options } from "ng5-slider";
import { GooglePlaceDirective } from "ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive";
// import {} from '@types/googlemaps';
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { ToastrService } from "ngx-toastr";
import { LOCAL_STORAGE, WebStorageService } from "ngx-webstorage-service";
import { forkJoin } from "rxjs";
import { CommonService } from "src/app/services/common.service";
import { FeaturesByPlanService } from "src/app/services/features-by-plan/features-by-plan.service";
import {
  ReviewsFeatures,
  ReviewStructure,
  REVIEW_SUBFEATURES,
} from "src/app/services/features-by-plan/interface/reviews";
import { ReviewSetupCacheService } from "src/app/services/review-setup-cache.service";
import { GlobalVariable } from "../../app.component";
import { DataService, Response } from "../../dataService/data.service";
@Component({
  selector: "app-review-setup",
  templateUrl: "./review-setup.component.html",
  styleUrls: ["./review-setup.component.scss"],
})
export class ReviewSetupComponent implements OnInit, AfterViewInit {
  @ViewChild("places") places: GooglePlaceDirective;
  @ViewChild("search") searchElement;
  @ViewChild("content", { read: ElementRef, static: true }) content: ElementRef;
  @ViewChild("content1", { read: ElementRef, static: false })
  content1: ElementRef;
  @ViewChild("DeleteConformationModel", { static: true })
  DeleteConformationModel: ElementRef;
  @ViewChild("placesRef") placesRef: GooglePlaceDirective;

  lat: number = 13.067439;
  lng: number = 80.237617;
  zoom: number = 15;
  competitor: any = [];
  private BASE_URL = GlobalVariable;
  public loading = false;
  outlet_id: string = this.storage.get("outlet_id");
  goal_track: any;
  negative_rating: any;
  request_channel: any;
  request_channels: any;
  automatic_esponse: any;
  feedback: any;
  feedback_activated: boolean;
  tagged_team: boolean;
  goal_number: number;
  request_frequency: number = 0;
  default_review_sort: string = "";
  goal_tracker: String;
  negative_rating_limit: number = 1;
  review_request_channel: String;
  review_response: String;
  closeResult: string;
  review_tag_list: any = "hai,hello";
  competitor_list: any;
  isValidFormSubmitted: boolean = true;
  competitor_validation: String;
  connectedplatform: String;
  customconnectedplatform: any = [];
  address: string;
  private geoCoder;
  private place_details;
  role: string = this.storage.get("role");

  clickReview: any = [];
  requestFrequency: any = [];
  defaultReviewSort: any = [
    {
      label: "Unreplied",
      value: "UNREPLIED",
    },
    {
      label: "Recent",
      value: "RECENT",
    },
    {
      label: "Oldest",
      value: "OLDEST",
    },
  ];

  minValue: number = 1;
  maxValue: number = 3;
  // options: Options = {
  //   floor: 0,
  //   ceil: 5,
  //   showTicksValues: true
  // };
  value: number = 3;
  manualRefresh: EventEmitter<void> = new EventEmitter<void>();
  options: Options = {
    floor: 1,
    ceil: 5,
    step: 1,
    // disabled: this.role !== 'Owner' ? true : false,
    showTicks: true,
    showTicksValues: true,
  };
  zceppa_status: boolean;
  url_auto_redirect_status: boolean;
  auto_redirect: any = "";
  connected_platform_g: String;
  connected_platform_f: String;
  auto_review_reply: boolean;
  review_request_redirect: boolean;
  auto_update_default_reply_template: boolean;
  google_place_id: boolean = false;
  show_message: boolean;
  permissions: any;
  review_click_steps: string = "0";
  displayName: any;
  is_reviews_blocked: any;
  reviews_warning_text: any = "";
  auto_review_reply_frequency: number;
  reviewFeatures: any;
  requestChannels: string[];
  reviewStructure: ReviewStructure = {
    tag_team_member: [
      "feature_reviews",
      REVIEW_SUBFEATURES.tag_team_member,
      "is_applicable",
    ],
    auto_reply: [
      "feature_reviews",
      REVIEW_SUBFEATURES.auto_reply,
      "is_applicable",
    ],
    reply_auto_update_template: [
      "feature_reviews",
      REVIEW_SUBFEATURES.reply_auto_update_template,
      "is_applicable",
    ],
    review_invite_channel_sms: [
      "feature_reviews",
      REVIEW_SUBFEATURES.review_invite_channel,
      "values",
      ["SMS"],
    ],
    enable_external_reviews: [
      "feature_reviews",
      REVIEW_SUBFEATURES.enable_external_reviews,
      "is_applicable",
    ],
    review_gateway: [
      "feature_reviews",
      REVIEW_SUBFEATURES.review_gateway,
      "is_applicable",
    ],
  };
  enable_external_review: boolean = false;
  review_gateway: boolean = false;

  constructor(
    private modalService: NgbModal,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
    private HttpService: DataService,
    public formBuilder: FormBuilder,
    private toastrService: ToastrService,
    private mapsAPILoader: MapsAPILoader,
    private commonService: CommonService,
    private ngZone: NgZone,
    private featuresByPlan: FeaturesByPlanService,
    private reviewSetupCache: ReviewSetupCacheService
  ) {}

  public handleAddressChange(address: Address) {
    if (this.role === "Owner") {
      let res: Response;
      // this.lng = address.geometry.location.lng();
      // this.lat  = address.geometry.location.lat();
      if (this.google_place_id === true) {
        this.modalService.dismissAll("content");
        const data_json = {
          place_id: address.place_id,
        };
        const data_service = this.HttpService.postjson(
          this.BASE_URL.GOOGLE_PLACE_ID(this.outlet_id),
          data_json
        );
        data_service.subscribe(
          (data: Response) => {
            res = data;
          },
          () => {
            //  console.log(error);
          },
          () => {
            if (res.code === 200 || res.code === 201) {
              this.toastrService.success(res.data["message"]);
              this.commonOnOnitService();
            } else {
              this.toastrService.error(res.data["message"]);
            }
          }
        );
      } else {
        this.competitor.push(address.name);
        this.modalService.dismissAll("content");
        // const data_service = this.HttpService.putjson(this.BASE_URL.COMPETITOR_SETUP_URL + '?outlet_id=' + this.outlet_id, data_json);
        // data_service.subscribe((data: Response) => {
        //   res = data;
        // }, error => {
        // console.log(error);
        // }, () => {
        //   this.toastrService.success(res.data['message']);
        //   const competitor_setup = this.HttpService.get(this.BASE_URL.COMPETITOR_SETUP_VALUE_URL, this.outlet_id);
        //   competitor_setup.subscribe((data: Response) => {
        //     res = data;
        //   }, error => {

        //   }, () => {
        //     this.competitor = [];
        //     this.competitor_list = res.data['insights'];
        //     this.competitor_list.forEach((val: any, key: any) => {
        //       this.competitor.push(val.name);
        //     });
        //   console.log(this.competitor);
        //   });
        // });
      }
    }
  }

  async getFeatures() {
    let reviewFeatures: ReviewsFeatures = await this.featuresByPlan.getFeatures(
      "feature_reviews"
    );
    this.reviewFeatures = reviewFeatures.plan_subfeatures;
    // let tagTeamMember: ReviewParams = [
    //   "feature_reviews",
    //   "custom_invite_template",
    //   "is_applicable",
    // ];
    // review_click_steps: 'one click';
    this.requestChannels = Object.keys(
      this.reviewFeatures.review_invite_channel.values
    );
    return;
  }

  ngOnInit() {
    this.loading = true;
    this.getFeatures();
    // this.spinnerService.show();
    console.log(google, "google lib");
    this.clickReview = [
      { title: "1  Click Review", value: "1" },
      { title: "2  Click Review", value: "2" },
    ];

    this.requestFrequency = [
      { title: "Not applicable", value: "0" },
      { title: "15 days", value: "15" },
      { title: "30 days", value: "30" },
      { title: "120 days", value: "120" },
      { title: "180 days", value: "180" },
      { title: "360 days", value: "360" },
    ];
    this.socialPlatforms();
    //this.connectedPlatforms();
    this.customconnectedPlatforms();
    // this.HttpService.get(this.BASE_URL.SOCIAL_AUTH_VERIFY_URL, this.outlet_id).subscribe((data: Response) => {
    //   this.loading = false;
    //   res = data;
    // }, error => {

    // }, () => {
    //   this.competitor_validation = res.data['google'];
    // });
    // this.competitor = ['Starbuks Coffee', 'Di bella coffee'];
    this.commonOnOnitService();

    // const review_setup = this.HttpService.get(this.BASE_URL.CAMPAIGN_CHANNELS, this.outlet_id).subscribe(res => {
    //   this.request_channels = res.data['channels'];
    // }, error => {

    // });
    // const googl = google;
    if (this.role === "Owner") {
      this.mapsAPILoader.load().then(() => {
        this.setCurrentLocation();
        this.geoCoder = new google.maps.Geocoder();
        // this.place_details = new google.maps.places.PlaceResult;
        const autocomplete = new google.maps.places.Autocomplete(
          this.searchElement && this.searchElement.nativeElement,
          {
            types: ["address"],
          }
        );
        autocomplete.addListener("place_changed", () => {
          this.ngZone.run(() => {
            // get the place result
            // let place: google.maps.places.PlaceResult = autocomplete.getPlace();
            this.place_details = autocomplete.getPlace();
            console.log("is called", this.place_details);
            // verify result
            if (
              this.place_details.geometry === undefined ||
              this.place_details.geometry === null
            ) {
              return;
            }

            // set latitude, longitude and zoom
            this.lat = this.place_details.geometry.location.lat();
            this.lng = this.place_details.geometry.location.lng();
            this.zoom = 12;
          });
        });
      });
    }
  }
  ngAfterViewInit() {}

  socialPlatforms() {
    let res: Response;
    this.HttpService.get(
      this.BASE_URL.SOCIAL_AUTH_VERIFY_URL(this.outlet_id)
    ).subscribe(
      (data: Response) => {
        this.loading = false;
        res = data;
      },
      () => {},
      () => {
        this.competitor_validation = res.data["google"];
        this.connected_platform_g = res.data["google"];
        this.connected_platform_f = res.data["facebook"];
      }
    );
  }
  // connectedPlatforms(){
  //   let res: Response;
  //   this.HttpService.get(this.BASE_URL.CONNECTED_PLATFORMS, this.outlet_id).subscribe((data: Response) => {
  //     this.loading = false;
  //     res = data;
  //   }, error => {

  //   }, () => {
  //     this.connectedplatform = res.data['integration_status'];
  //     console.log('connectedplatform',this.connectedplatform);
  //   });
  // }
  customconnectedPlatforms() {
    let res: Response;
    this.HttpService.get(
      this.BASE_URL.CUSTOM_INTEG_ALL(this.outlet_id)
    ).subscribe(
      (data: Response) => {
        this.loading = false;
        res = data;
      },
      () => {},
      () => {
        this.customconnectedplatform = res.data["integrations"];
        console.log("customconnectedplatform", this.customconnectedplatform);
      }
    );
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.lat = position.coords.latitude;
        this.lng = position.coords.longitude;
        this.zoom = 15;
        this.getAddress(this.lat, this.lng);
      });
    }
  }

  markerDragEnd($event: MouseEvent) {
    // console.log($event);
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
    this.getAddress(this.lat, this.lng);
  }
  mapClicked($event: MouseEvent) {
    this.lat = $event.coords.lat;
    this.lng = $event.coords.lng;
  }

  getAddress(latitude, longitude) {
    this.geoCoder.geocode(
      { location: { lat: latitude, lng: longitude } },
      (results, status) => {
        //  console.log(results);
        if (status === "OK") {
          if (results[0]) {
            this.zoom = 15;
            this.address = results[0].formatted_address;
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }

  /**
   * Common on service init function for api request
   *
   * @memberof ReviewSetupComponent
   */
  commonOnOnitService() {
    this.outlet_id = this.storage.get("outlet_id");
    let res: any;
    const review_setup = this.HttpService.get(
      this.BASE_URL.REVIEW_SETUP_URL_V2(this.outlet_id)
    );
    // Use cached service to prevent race conditions when multiple components call this API
    const setup_value = this.reviewSetupCache.getReviewSetupValue(this.outlet_id);
    if (this.role === "Owner") {
      // this.HttpService.get(this.BASE_URL.COMPETITOR_LIST_URL, this.outlet_id).subscribe((data: Response) => {
      //   resp = data;
      // }, error => {
      // }, () => {
      //   this.competitor_list = resp.data['insights'];
      //   this.competitor_list.forEach((val: any, key: any) => {
      //     this.competitor.push(val.name);
      //   });
      // });
      forkJoin([review_setup, setup_value]).subscribe(
        (data) => {
          res = data;
        },
        () => {},
        () => {
          this.goal_track = res[0].data["goal_track"];
          this.negative_rating = res[0].data["negative_rating"];
          let request_channel = res[0].data["request_channel"];
          this.request_channel = request_channel.filter((item) =>
            this.requestChannels.includes(item)
          );
          this.automatic_esponse = res[0].data["automatic_response"];
          this.feedback = res[0].data["send_feedback"];
          // this.options = {
          //   floor: this.negative_rating[this.negative_rating.length - 1],
          //   ceil: this.negative_rating.length,
          //   step: 1,
          //   showTicks: true,
          //   showTicksValues: true,
          // };
          this.permissions = res[1].data.permissions;
          // this.feedback_activated = res[1].data['feedback_activated'] === 'yes' ? true : false;
          this.review_click_steps =
            res[1].data["review_click_steps"] === 1 ? "1" : "2";
          console.log(this.review_click_steps);
          this.displayName = res[1].data["display_name"];
          this.tagged_team =
            res[1].data["tagged_team"] === "yes" ? true : false;
          this.goal_number = res[1].data["goal_number"];
          if (res[1].data["request_frequency"] == "None") {
            this.request_frequency = 0;
          } else {
            this.request_frequency = res[1].data["request_frequency"];
          }
          this.default_review_sort = res[1].data["default_review_sort"];
          this.enable_external_review = res[1].data["enable_external_review"];
          this.review_gateway = res[1].data["review_gateway"];
          this.goal_tracker = res[1].data["goal_tracking"];
          this.negative_rating_limit = res[1].data["negative_rating_limit"];
          if (res[1].data["review_request_channel"] === "sms") {
            this.review_request_channel = "SMS";
          } else if (res[1].data["review_request_channel"] === "email") {
            this.review_request_channel = "Email";
          }
          // this.review_request_channel = res[1].data['review_request_channel'] === 'sms' ? 'SMS' : res[1].data['review_request_channel'];
          this.review_response = res[1].data["review_response"];
          this.auto_redirect = res[1].data["auto_redirect"];
          console.log(this.auto_redirect);
          this.zceppa_status =
            res[1].data["zceppa_status"] === "On" ? true : false;
          this.url_auto_redirect_status =
            res[1].data["url_auto_redirect_status"] === "On" ? true : false;
          this.auto_review_reply =
            res[1].data["auto_review_reply"] === "on" ? true : false;
          this.review_request_redirect = res[1].data["review_request_redirect"];
          this.auto_update_default_reply_template =
            res[1].data["auto_update_default_reply_template"] === "yes"
              ? true
              : false;
          this.auto_review_reply_frequency =
            res[1].data["auto_review_reply_frequency"];
          if (res[1].data["maps_place_id"] === null) {
            this.show_message = false;
          } else {
            this.show_message = true;
          }
          this.is_reviews_blocked = res[1].data["is_product_blocked"];
          this.reviews_warning_text = res[1].data["product_warning_text"];
          // console.log(res[1].data);
          this.storage.set(
            "default_template_id",
            res[1].data["default_sms_template"]
          );
          setTimeout(() => {
            this.manualRefresh.emit();
          }, 0);
        }
      );
    } else {
      forkJoin([review_setup, setup_value]).subscribe(
        (data) => {
          res = data;
        },
        () => {},
        () => {
          this.goal_track = res[0].data["goal_track"];
          this.negative_rating = res[0].data["negative_rating"];
          let request_channel = res[0].data["request_channel"];
          this.request_channel = request_channel.filter((item) =>
            this.requestChannels.includes(item)
          );
          this.automatic_esponse = res[0].data["automatic_response"];
          this.feedback = res[0].data["send_feedback"];

          this.permissions = res[1].data.permissions;
          // this.feedback_activated = res[1].data['feedback_activated'] === 'yes' ? true : false;
          this.review_click_steps =
            res[1].data["review_click_steps"] === 1 ? "1" : "2";
          // console.log(this.review_click_steps);

          this.tagged_team =
            res[1].data["tagged_team"] === "yes" ? true : false;
          this.goal_number = res[1].data["goal_number"];
          //this.request_frequency = res[1].data['request_frequency'];
          if (res[1].data["request_frequency"] == "None") {
            this.request_frequency = 0;
          } else {
            this.request_frequency = res[1].data["request_frequency"];
          }
          this.default_review_sort = res[1].data["default_review_sort"];
          this.goal_tracker = res[1].data["goal_tracking"];
          this.negative_rating_limit = res[1].data["negative_rating_limit"];
          if (res[1].data["review_request_channel"] === "sms") {
            this.review_request_channel = "SMS";
          } else if (res[1].data["review_request_channel"] === "email") {
            this.review_request_channel = "Email";
          }
          this.displayName = res[1].data["display_name"];
          this.review_response = res[1].data["review_response"];
          this.zceppa_status =
            res[1].data["zceppa_status"] === "On" ? true : false;
          this.url_auto_redirect_status =
            res[1].data["url_auto_redirect_status"] === "On" ? true : false;
          this.auto_redirect = res[1].data["auto_redirect"];
          console.log(this.auto_redirect);
          this.auto_review_reply =
            res[1].data["auto_review_reply"] === "on" ? true : false;
          this.review_request_redirect = res[1].data["review_request_redirect"];
          this.auto_update_default_reply_template =
            res[1].data["auto_update_default_reply_template"];
          this.auto_review_reply_frequency =
            res[1].data["auto_review_reply_frequency"];
          this.storage.set(
            "default_template_id",
            res[1].data["default_sms_template"]
          );
          setTimeout(() => {
            this.manualRefresh.emit();
          }, 0);
        }
      );
    }
  }

  /**
   * Update review setup
   *
   * @memberof ReviewSetupComponent
   */
  onSubmit() {
    let res: Response;
    this.isValidFormSubmitted = false;
    if (
      (this.auto_update_default_reply_template &&
        this.auto_review_reply_frequency == 0) ||
      (this.tagged_team && !this.displayName.length)
    ) {
      return;
    }
    this.isValidFormSubmitted = true;
    const data_json = {
      // 'feedback_activated': this.feedback_activated === true ? 'yes' : 'no',
      feedback_activated: "yes",
      review_click_steps: this.review_click_steps === "1" ? 1 : 2,
      tagged_team: this.tagged_team === true ? "yes" : "no",
      goal_number: Number(this.goal_number),
      request_frequency: Number(this.request_frequency),
      default_review_sort: this.default_review_sort ?? "RECENT",
      goal_tracker: this.goal_tracker,
      negative_rating_limit: this.negative_rating_limit,
      review_request_channel: this.review_request_channel,
      review_response: this.review_response,
      zceppa_status: this.zceppa_status === true ? "On" : "Off",
      url_auto_redirect_status:
        this.url_auto_redirect_status === true ? "On" : "Off",
      auto_review_reply: this.auto_review_reply === true ? "on" : "off",
      review_request_redirect: this.review_request_redirect,
      auto_update_default_reply_template:
        this.auto_update_default_reply_template === true ? "yes" : "no",
      auto_redirect: this.auto_redirect,
      display_name: this.displayName,
      auto_review_reply_frequency:
        this.auto_review_reply_frequency == 0
          ? (this.auto_review_reply_frequency = 7)
          : Number(this.auto_review_reply_frequency),
      review_gateway: this.review_gateway,
      enable_external_review: this.enable_external_review,
    };
    const data_service = this.HttpService.putjson(
      this.BASE_URL.REVIEW_SETUP_UPDATE_URL_V2(this.outlet_id),
      data_json
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.warning(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201 || res.code === 206) {
          this.toastrService.success("Updated Review Settings successfully");
          this.commonService.checkOnboardNotification("reviews");
          //this.connectedPlatforms();
          //this.customconnectedPlatforms();
        } else {
          this.toastrService.warning(res.data["message"]);
        }
      }
    );
  }

  /**
   * Open model service function
   *
   * @param {*} content
   * @memberof ReviewSetupComponent
   */
  open(content) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modalreviewadd",
        size: "lg",
        windowClass: "modal-xl",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  open1(content1) {
    this.modalService
      .open(content1, {
        ariaLabelledBy: "modalreviewadd",
        size: "lg",
        windowClass: "modal-xl",
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason1(reason)}`;
        }
      );
  }

  /**
   * Close popup model
   *
   * @private
   * @param {*} reason
   * @returns {string}
   * @memberof ReviewSetupComponent
   */
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  private getDismissReason1(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
  /**
   * On competitor analysis
   *
   * @param {*} event
   * @param {*} content
   * @memberof ReviewSetupComponent
   */
  onInputBlurred(content) {
    this.google_place_id = false;
    if (this.role === "Owner") {
      if (this.competitor_validation === "connected") {
        if (this.competitor.length < 2) {
          this.modalService
            .open(content, {
              ariaLabelledBy: "modalreviewadd",
              size: "lg",
              windowClass: "modal-xl",
            })
            .result.then(
              (result) => {
                this.closeResult = `Closed with: ${result}`;
              },
              (reason) => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
              }
            );
        }
      } else {
        this.toastrService.error(
          "Please Integrate Your My Business Google Account"
        );
      }
    }
  }

  googleID(content1) {
    if (this.show_message === true) {
      this.open(this.DeleteConformationModel);
    } else {
      this.google_place_id = true;
      this.modalService
        .open(content1, {
          ariaLabelledBy: "modalreviewadd",
          size: "lg",
          windowClass: "modal-xl",
        })
        .result.then(
          (result) => {
            this.closeResult = `Closed with: ${result}`;
          },
          (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason1(reason)}`;
          }
        );
    }
  }

  /**
   * Disconnect mapls place id
   */
  disconnectMapsPlaceId() {
    let res: Response;
    this.outlet_id = this.storage.get("outlet_id");
    const data_service = this.HttpService.get(
      this.BASE_URL.REVIEW_MAPS_PLACE_DISCONNECT_URL(this.outlet_id)
    );
    data_service.subscribe(
      (data: Response) => {
        res = data;
      },
      (error) => {
        this.toastrService.error(error.error.message);
      },
      () => {
        if (res.code === 200 || res.code === 201) {
          this.toastrService.success(res.data["message"]);
          this.commonOnOnitService();
          this.modalService.dismissAll();
        } else {
          this.toastrService.error(res.data["message"]);
          this.modalService.dismissAll();
        }
      }
    );
  }

  /**
   * On item removed to competitor array
   *
   * @param {*} event
   * @memberof ReviewSetupComponent
   */
  onItemRemoved() {
    // this.modalService.dismissAll('content');
    // this.competitor_list.forEach((val: any, key: any) => {
    //   if (val.name === event) {
    //    // console.log(event);
    //     this.removeCompetitorList(val.id);
    //   }
    // });
  }

  /**
   * Google place id delete
   *
   * @param {*} place_id
   * @memberof ReviewSetupComponent
   */
  removeCompetitorList() {
    // let res: Response;
    // const data_json = {
    //   'competitor_id': place_id
    // };
    // const data_service = this.HttpService.postjson(this.BASE_URL.COMPETITOR_DELETE_URL + '?outlet_id=' + this.outlet_id, data_json);
    // data_service.subscribe((data: Response) => {
    //   res = data;
    // }, error => {
    //   this.toastrService.error(error.error.message);
    // }, () => {
    //   this.toastrService.success(res.data['message']);
    // });
  }

  /**
   * Zceppa status change issue fix
   */
  publishNegativeReviewChange(event) {
    // console.log(event);
    this.feedback_activated = event;
  }

  reviewTagPeopleChange(event) {
    // console.log(event);
    this.tagged_team = event;
  }

  reviewGatewayChange(event) {
    this.review_gateway = event;
  }

  enableExternalReview(event) {
    this.enable_external_review = event;
  }

  /**
   * Zceppa status change issue fix
   */
  zceppaStatusChange(event) {
    // console.log(event);
    this.zceppa_status = event;
  }
  /**
   * Zceppa url_auto_redirect_status change issue fix
   */
  zceppaRedirectStatusChange(event) {
    // console.log(event);
    this.url_auto_redirect_status = event;
  }
  /**
   * Zceppa auto_review_reply change issue fix
   */
  zceppaAutoReviewReplyStatusChange(event) {
    // console.log(event);
    this.auto_review_reply = event;
  }

  /**
   * Zceppa auto_update_default_reply_template change issue fix
   */
  zceppaautoUpdateDefaultReplyTemplateStatusChange(event) {
    // console.log(event);
    this.auto_update_default_reply_template = event;
  }
  changeReviewRequestLink(event) {
    this.review_request_redirect = event;
  }
}
